import { createApp } from 'vue/dist/vue.esm-bundler';
import { createRouter, createWebHistory } from 'vue-router';
import Home from './pages/Home.vue';
import AboutUs from './pages/AboutUs.vue';
import Services from './pages/Services.vue';
import MainLayout from './layouts/MainLayout.vue';
import axios from 'axios';
import Chat from './pages/Chat.vue'
import store from '../src/store/chat/chat'

const PageNotFound = { template: '<h1>Not found</h1>' };

const routes = [
  {
    path: '/',
    component: MainLayout,
    children: [
      { path: '', name: 'home', component: Home },
      { path: 'nosotros', name: 'nosotros', component: AboutUs },
      { path: 'servicios', name: 'servicios', component: Services },
      { path: 'chat', name: 'chat', component: Chat }
    ],
  },
  { path: '/:pathMatch(.*)*', component: PageNotFound },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

const app = createApp({});
app.config.globalProperties.$axios = axios;
app.use(router);
app.use(store);
app.mount('#app');

require('@/assets/css/main.css');
